import TopHeader from "../components/topHeader/TopHeader";
import { BaseButton } from "../components/base";
import { useNavigate } from "react-router-dom";
import URIs from "../utils/uri";
import { useTheme, Typography } from "@mui/material";
import useAuth from "../hooks/useAuth";
import GoldBoxList from "../components/goldBox/GolBoxList";

const Goldbox = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const {auth} = useAuth();
    
    return (
        <div>
            <TopHeader>
                <Typography
                    variant="caption"
                    color='textDefault'
                    sx={{
                        width: "40%",
                        marginLeft: "20px",
                    }}
                >
                    صندوقچه
                </Typography>
            </TopHeader>
            <GoldBoxList/>
        </div>
    )
}
export default Goldbox;